import { ControlType } from '../controltype';
import { TextValue } from './textvalue';
import { NumberRangeValueConvertor } from './numberrangevaue';
import { DateRangeValue } from './daterangevalue';
import { HelpValue } from './helpvalue';
import { DropDownListValueConvert } from './dropdownlistvalue';
import { ComboLookUpValue } from './combolookupvalue';

export interface IValue {
    getControlType(): ControlType;
    getOriginalValue(): any;
    setOriginalValue(value: any): void;
    clearValue(): void;
    isEmpty(): boolean;
}

export class ConditionValueConvert {
    convertToObject(obj: IValue): Object {
        let conditionValue = obj as IValue;
        let controlType = conditionValue.getControlType();
        let jobj = new Object();
        jobj['Type'] = controlType;
        if (controlType == ControlType.DropDown) {
            let convertor = new DropDownListValueConvert();
            jobj['Content'] = convertor.convertToObject(conditionValue);
        }
        else if (controlType == ControlType.NumberRange) {
            let convertor = new NumberRangeValueConvertor();
            jobj['Content'] = convertor.convertToObject(conditionValue);
        }
        else {
            jobj['Content'] = conditionValue;
        }
        return jobj;
    }

    initFromObject(jobj: Object): IValue {
        let controlType = jobj['Type'] as ControlType;
        let content: IValue = jobj['Content'];
        if (controlType == ControlType.Text) {
            return Object.assign(new TextValue(), content as TextValue);
        }
        else if (controlType == ControlType.NumberRange) {
            let convertor = new NumberRangeValueConvertor();
            return convertor.initFromObject(content);
        }
        else if (controlType == ControlType.DateRange) {
            return Object.assign(new DateRangeValue(), content as DateRangeValue);
        }
        else if (controlType == ControlType.DropDown) {
            let convertor = new DropDownListValueConvert();
            return convertor.initFromObject(content);
        }
        else if (controlType == ControlType.Help) {
            return Object.assign(new HelpValue(), content as HelpValue);
        }
        else if (controlType == ControlType.ComboLookUp) {
            return Object.assign(new ComboLookUpValue(), content as ComboLookUpValue);
        };
    }
}